<template>
  <div class="page">
    <div class="card">
      <h1>Datenschutzerklärung</h1>

      <section>
        <h2>1. Verantwortlicher</h2>
        <p>
          Verantwortlich für die Datenverarbeitung auf dieser Website ist:
        </p>
        <p>
          Jean-Marie Hardt<br>
          Rue de Hoscheid<br>
          9380 Merscheid<br>
          Luxemburg<br><br>
          Telefon: +352 691 624 657<br>
          E-Mail: hardt.jim@gmail.com
        </p>
      </section>

      <section>
        <h2>2. Hosting</h2>
        <p>
          Diese Website wird bei IONOS SE, Elgendorfer Straße 57, 56410 Montabaur, Deutschland, gehostet.
          Beim Besuch der Website erfasst der Hosting-Anbieter automatisch sogenannte Server-Logfiles.
        </p>
        <p>
          Erfasst werden insbesondere:
        </p>
        <ul>
          <li>IP-Adresse</li>
          <li>Datum und Uhrzeit der Anfrage</li>
          <li>Browsertyp und -version</li>
          <li>Betriebssystem</li>
          <li>Referrer-URL</li>
        </ul>
        <p>
          Diese Daten dienen ausschließlich der technischen Sicherheit und Stabilität der Website.
          Die Verarbeitung erfolgt gemäß Art. 6 Abs. 1 lit. f DSGVO auf Grundlage des berechtigten Interesses
          an einem sicheren und stabilen Betrieb.
        </p>
      </section>

      <section>
        <h2>3. Kontaktaufnahme</h2>
        <p>
          Wenn Sie per E-Mail Kontakt aufnehmen, werden die von Ihnen übermittelten Daten
          (z.B. Name, E-Mail-Adresse, Inhalt der Nachricht) ausschließlich zur Bearbeitung Ihrer Anfrage verwendet.
        </p>
        <p>
          Eine Weitergabe an Dritte erfolgt nicht.
          Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (vorvertragliche Maßnahmen)
          bzw. Art. 6 Abs. 1 lit. f DSGVO.
        </p>
      </section>

      <section>
        <h2>4. Cookies</h2>
        <p>
          Diese Website verwendet keine Cookies zu Analyse- oder Marketingzwecken.
        </p>
        <p>
          Es werden lediglich technisch notwendige Session-Daten verwendet,
          sofern Sie den geschützten Administrationsbereich nutzen.
        </p>
      </section>

      <section>
        <h2>5. Schriftarten</h2>
        <p>
          Auf dieser Website verwendete Schriftarten sind lokal gespeichert.
          Es findet keine Verbindung zu externen Schriftanbieter-Servern statt.
        </p>
      </section>

      <section>
        <h2>6. Ihre Rechte</h2>
        <p>
          Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit das Recht auf:
        </p>
        <ul>
          <li>Auskunft über Ihre gespeicherten Daten</li>
          <li>Berichtigung unrichtiger Daten</li>
          <li>Löschung Ihrer Daten</li>
          <li>Einschränkung der Verarbeitung</li>
          <li>Datenübertragbarkeit</li>
          <li>Widerspruch gegen die Verarbeitung</li>
        </ul>
        <p>
          Zudem haben Sie das Recht, sich bei einer Datenschutzaufsichtsbehörde zu beschweren.
        </p>
      </section>

      <section>
        <h2>7. Aktualität</h2>
        <p>
          Diese Datenschutzerklärung hat den Stand Mai 2026.
          Änderungen behalten wir uns vor, um sie an geänderte Rechtslagen oder technische Entwicklungen anzupassen.
        </p>
      </section>

    </div>
  </div>
</template>

<script>
export default {}
</script>

<style scoped>
.page{
  max-width:1000px;
  margin:40px auto;
  padding:0 16px;
  color:#fff;
}

.card{
  background:rgba(255,255,255,.04);
  border:1px solid rgba(255,255,255,.08);
  border-radius:14px;
  padding:24px;
}

h1{
  margin-bottom:20px;
  font-size:28px;
}

h2{
  margin-top:24px;
  margin-bottom:10px;
  font-size:18px;
}

p{
  line-height:1.7;
  opacity:.9;
}

ul{
  padding-left:20px;
  line-height:1.7;
  opacity:.9;
}

section{
  margin-bottom:16px;
}
</style>